import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=05e0a149"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e0a149')) {
      api.createRecord('05e0a149', component.options)
    } else {
      api.reload('05e0a149', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=05e0a149", function () {
      api.rerender('05e0a149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/Footer.vue"
export default component.exports